<template>
  <h2>Error 404</h2>
</template>

<script>
export default {};
</script>
